import { render, staticRenderFns } from "./BindCard.vue?vue&type=template&id=7b91053e&scoped=true"
import script from "./BindCard.vue?vue&type=script&lang=js"
export * from "./BindCard.vue?vue&type=script&lang=js"
import style0 from "./BindCard.vue?vue&type=style&index=0&id=7b91053e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b91053e",
  null
  
)

export default component.exports